/* SolNow — cliente API de la ticketera nativa */
/* global axios */
import ApiClient from './ApiClient';

class TicketsAPI extends ApiClient {
  constructor() {
    super('tickets', { accountScoped: true });
  }

  // Cementerio: trae los tickets eliminados (soft delete) para la vista "Eliminados".
  getDeleted() {
    return axios.get(this.url, { params: { deleted: true } });
  }

  // Restaura un ticket del cementerio al tablero.
  restore(id) {
    return axios.patch(`${this.url}/${id}/restore`);
  }
}

export default new TicketsAPI();
